var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "kee-list" },
    [
      _c("VHeader"),
      _c("div", { staticClass: "content-wrap" }, [
        _c("div", { staticClass: "__opts" }, [
          _c("div", [_c("NewKeeBreadcrumb")], 1),
          _c(
            "div",
            { staticClass: "search-content" },
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: _vm.$t("please_input") },
                  model: {
                    value: _vm.searchInput,
                    callback: function ($$v) {
                      _vm.searchInput = $$v
                    },
                    expression: "searchInput",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        slot: "append",
                        icon: "el-icon-search",
                        type: "primary",
                        size: "small",
                      },
                      on: { click: _vm.getTable },
                      slot: "append",
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("btn_search2")) +
                          "\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
              !_vm.isKpmgUser
                ? _c(
                    "el-button",
                    {
                      staticClass: "wl-green-small favourite",
                      attrs: { icon: "el-icon-star-off", size: "small" },
                      on: { click: _vm.goToMyCourse },
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.$t("kee_my")) + "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "content-list-box" },
          [
            _c(
              "el-tabs",
              {
                staticClass: "kee-tabs",
                on: {
                  "tab-click": function ($event) {
                    return _vm.onSizeChange(8)
                  },
                },
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              [
                _vm._l(_vm.menu, function (item, index) {
                  return [
                    _c("el-tab-pane", {
                      attrs: { label: _vm.$t(item.name), name: item.tag },
                    }),
                  ]
                }),
              ],
              2
            ),
            _vm.courseList.length
              ? _c(
                  "div",
                  { staticClass: "course-list" },
                  _vm._l(_vm.courseList, function (item) {
                    return _c(
                      "div",
                      { key: item.courseId, staticClass: "course-item-outer" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "course-item",
                            on: {
                              click: function ($event) {
                                return _vm.goDetail(item)
                              },
                            },
                          },
                          [
                            item.newCourseFlag
                              ? _c("div", {
                                  class: [
                                    "isNew",
                                    _vm.$i18n.locale === "en" ? "__en" : "",
                                  ],
                                })
                              : _vm._e(),
                            _c("img", {
                              staticClass: "course-pic",
                              attrs: { src: item.coverImgUrl, alt: "" },
                            }),
                            _c(
                              "div",
                              { staticClass: "title-row" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: item.title,
                                      disabled: item.title.length <= 24,
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "course-title" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(item.title) +
                                          "\n                "
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "course-price" },
                              [
                                _c(
                                  "el-tag",
                                  { attrs: { type: "primary", size: "mini" } },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.form) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-tag",
                                  {
                                    staticStyle: { "margin-left": "10px" },
                                    attrs: {
                                      type:
                                        item.chargeType === "FREE"
                                          ? "success"
                                          : "danger",
                                      size: "mini",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          item.chargeType === "FREE"
                                            ? _vm.$t("kee_free")
                                            : _vm.$t("kee_charge")
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "course-item-child" }, [
                              _c("div", { staticClass: "course-time" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.form === "ONLINE",
                                        expression: "item.form === 'ONLINE'",
                                      },
                                    ],
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("kee_duration")) +
                                        ": " +
                                        _vm._s(
                                          _vm.durationTrans(
                                            item.sumDurationFormat
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                {
                                  class: [
                                    "course-collect",
                                    _vm.getUser.userType == "2"
                                      ? ""
                                      : "course-collect-kp",
                                  ],
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.collectClick(item)
                                    },
                                  },
                                },
                                [
                                  item.collectFlag
                                    ? _c("img", {
                                        staticClass: "collect-icon",
                                        attrs: {
                                          src: require("@/assets/img/icon-collect.svg"),
                                          width: "100%",
                                        },
                                      })
                                    : _c("img", {
                                        staticClass: "collect-icon",
                                        attrs: {
                                          src: require("@/assets/img/icon-uncollect.svg"),
                                          width: "100%",
                                        },
                                      }),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("kee_like"))),
                                  ]),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _c("el-empty", {
                  staticClass: "course-list",
                  attrs: { description: _vm.$t("comming_soon") },
                }),
            _c("el-pagination", {
              staticClass: "wl-pagination",
              attrs: {
                "current-page": _vm.pagination.pageNum,
                "page-size": _vm.pagination.pageSize,
                "page-sizes": [8, 16, 24, 48, 96],
                layout: "prev, pager, next, sizes, total",
                total: _vm.pagination.total,
              },
              on: {
                "size-change": _vm.onSizeChange,
                "current-change": _vm.onCurrentPageChange,
              },
            }),
          ],
          1
        ),
        _vm.activeName === "TAX_COURSES"
          ? _c(
              "div",
              { class: ["qrcode", _vm.isOpen ? "is-open" : "not-open"] },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isOpen,
                        expression: "!isOpen",
                      },
                    ],
                    staticClass: "not-open-inner",
                    attrs: { title: _vm.$t("kpmgFinanceOnline") },
                    on: {
                      click: function ($event) {
                        _vm.isOpen = !_vm.isOpen
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/kee/icon.png"),
                        width: "25",
                        alt: "",
                      },
                    }),
                    _c("div", [_vm._v(_vm._s(_vm.$t("kpmgFinanceOnline")))]),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isOpen,
                        expression: "isOpen",
                      },
                    ],
                    staticClass: "is-open-inner",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "close",
                        on: {
                          click: function ($event) {
                            _vm.isOpen = !_vm.isOpen
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("fold")) +
                            " X\n        "
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "tit" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/kee/icon.png"),
                          width: "25",
                          alt: "",
                        },
                      }),
                      _c("span", [_vm._v(_vm._s(_vm.$t("kpmgFinanceOnline")))]),
                    ]),
                    _c("img", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        src: require("@/assets/img/kee/qrcode.png"),
                        alt: "",
                      },
                    }),
                    _c("p", [_vm._v(_vm._s(_vm.$t("qrcodeTips")))]),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ]),
      _c("vBottom"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }